import { Box } from '@mui/material';
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl';
import { ReactElement, useEffect, useState } from 'react';
import { tokens } from '@synergy/theme-palo';

import { MemberOrderLimits } from '../models/member-purchase-order';
import { useThunkDispatch } from '../../../store/use-thunk-dispatch';

/**
 * "Dein Bestelllimit: x € von y € im Oktober verbraucht · je Bestellung bis
 * z €" — every member sees their own (GF 15.10.2026, #2279). Without a limit
 * the line is left out.
 */
export const PaloOrderLimitLine = ({ currency }: { currency: string }): ReactElement | null => {
    const dispatch = useThunkDispatch();
    const intl = useIntl();
    const [limits, setLimits] = useState<MemberOrderLimits>();

    useEffect(() => {
        void dispatch(async (_dispatch, _getState, { api }) => {
            const result = await api.orders.getLimits();
            setLimits(result.success ? result.result : undefined);
        });
    }, [dispatch]);

    const monthly = limits?.monthlyOrderLimit ?? undefined;
    const perOrder = limits?.perOrderOrderLimit ?? undefined;

    if (undefined === monthly && undefined === perOrder) {
        return null;
    }

    const money = (value: number) => <FormattedNumber value={value} style="currency" currency={currency} />;

    return (
        <Box sx={{ mb: '10px', fontSize: '12.5px', color: tokens.color.ink2 }}>
            <Box component="span" sx={{ fontWeight: 600, mr: '4px' }}>
                <FormattedMessage id="app.orders.limit.title" />
            </Box>
            {undefined !== monthly && (
                <FormattedMessage
                    id="app.orders.limit.monthly"
                    values={{
                        used: money(limits?.currentMonthlyOrderSum ?? 0),
                        limit: money(monthly),
                        month: intl.formatDate(new Date(), { month: 'long' }),
                    }}
                />
            )}
            {undefined !== monthly && undefined !== perOrder && ' · '}
            {undefined !== perOrder && (
                <FormattedMessage id="app.orders.limit.perOrder" values={{ limit: money(perOrder) }} />
            )}
        </Box>
    );
};
